import { FAQPageJsonLd } from 'next-seo';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

const FrequentAskedQuestions = ({ className, faqs }) => (
  <div className={className}>
    <Heading as="h2" className="mb-2" size="size3">
      {placeholder('titles.faq')}
    </Heading>
    {faqs.map(({ question, answer }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Fragment key={index}>
        <Heading as="h3" className="mt-4" size="size4">
          {question.trim()}
        </Heading>
        <Text className="mt-4">{answer.trim()}</Text>
      </Fragment>
    ))}
    <FAQPageJsonLd
      mainEntity={faqs.map(({ question, answer }) => ({
        questionName: question.trim(),
        acceptedAnswerText: answer.trim(),
      }))}
    />
  </div>
);

FrequentAskedQuestions.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  faqs: PropTypes.arrayOf(
    PropTypes.shape({ question: PropTypes.string, answer: PropTypes.string })
  ).isRequired,
};

export default FrequentAskedQuestions;
